import { createSlice } from "@reduxjs/toolkit";
import { readStoredId, readStoredString } from "../storage";

const initialState = {
  token: readStoredString("token"),
  userId: readStoredId("userId"),
};
export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    login: (state, payload) => {
      const { token, userId, role } = payload.payload;

      state.token = token;
      state.userId = userId;
      state.auth = payload.payload;
      localStorage.setItem("auth", JSON.stringify(payload.payload));
      localStorage.setItem("token", JSON.stringify(token));
      localStorage.setItem("userId", JSON.stringify(userId));
      localStorage.setItem("loginTime", JSON.stringify(new Date()));
    },
    logout: (state) => {
      localStorage.removeItem("token");
      localStorage.removeItem("userId");
      localStorage.removeItem("s");
      localStorage.removeItem("loginTime");
      localStorage.removeItem("auth");
      state.token = null;
      state.userId = null;
      state.auth = null;
    },
  },
});

export default userSlice.reducer;
export const { login, logout } = userSlice.actions;
